<template>
  <div :class="['m-form-item', compact ? '-compact' : '']">
    <div
      v-if="label !== ''"
      class="_label"
    >
      {{ label }}
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MFormItem',
  props: {
    label: {
      type: String,
      default: '',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .m-form-item {
    margin-bottom: 2.4rem;

    ._label {
      margin-bottom: .4rem;
      color: $font-color-secondary;
    }

    &.-compact {
      margin-bottom: 1rem;

      ._label {
        margin-bottom: .1rem;
      }
    }
  }
</style>
